import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useLocation } from 'react-router-dom'
import { useOnlineStatus } from '../Hooks/useOnlineStatus'
import { OFFLINE_CAPABLE_PATHS } from '../../offline/offlinePaths'

function OfflineUnavailableView() {
  return (
    <div className="flex flex-col items-center justify-center h-full py-16 text-theme-text text-center px-6">
      <FontAwesomeIcon icon={faCircleExclamation} className="text-5xl text-theme-warning mb-4" />
      <h2 className="text-xl font-semibold mb-2">Not available offline</h2>
      <p className="text-sm max-w-sm">
        This page is not available without an internet connection. Navigate to Operations, Stoppages, or Production to continue working.
      </p>
    </div>
  )
}

interface OfflineGuardProps {
  children: React.ReactNode
}

const OfflineGuard = ({ children }: OfflineGuardProps) => {
  const isOnline = useOnlineStatus()
  const { pathname } = useLocation()

  if (!isOnline && !OFFLINE_CAPABLE_PATHS.has(pathname)) {
    return <OfflineUnavailableView />
  }

  return <>{children}</>
}

export default OfflineGuard
